import {createContext} from 'react';
export const {Provider:LinkContextProvider, Consumer:LinkContextConsumer} = createContext(false);
